<template>
  <div class="consolidate_consum_holder">
    <div class="parcel_info_text">
      Parcela <span class="parcel_info_text_dark">{{ parcel_name }}</span> ({{ parcel_surface }} ha) Recolta
      <span class="parcel_info_text_dark">{{ totalWeightKg | getLocalFormattedQuantity }}</span> kg insemnând
      <span class="parcel_info_text_dark">{{ totalWeightKgPerHa | getLocalFormattedQuantity }}</span> kg/ha.
    </div>
    <div class="consum_title_holder">
      <div class="consum_title">Produse</div>
    </div>
    <DxScrollView ref="scrollView" :elementAttr="scrollListAttributes" @scroll="scroll" :use-native="true" reachBottomText="Se încarcă...">
      <div>
        <div class="no_dataLabel" v-if="noListData">Nu există recolta</div>
        <div v-for="(data, d_idx) in production_list_data" :key="data.data_idx_uuid">
          <div class="product_date">{{ data.date }}</div>
          <div class="con_consum_list_holder">
            <div v-for="(product, p_idx) in data.products" :key="product.idx_uuid">
              <div class="product_item">
                <div class="product_main_icon">
                  <div class="product_main_icon_file">
                    <img src="@/assets/images/icons/droplet.svg" />
                  </div>
                </div>
                <div class="product_main_info">
                  <div class="product_name">{{ product.product_name + " (" + product.product_code + ")" }}</div>
                </div>
                <div class="dose_info">
                  {{ (parseFloat(product.quantity) / parseFloat(parcel_surface ?? 1)) | getLocalFormattedQuantity }}
                  {{ product.measure_unit_symbol }}/ha
                </div>
                <div class="expand_icon_holder">
                  <div :class="product.expanded ? 'expand_icon_expanded' : 'expand_icon'" @click="expandProduct(product, d_idx, p_idx)">
                    <img v-if="product.expanded" src="@/assets/images/icons/arrow_up_green.svg" />
                    <img v-else src="@/assets/images/icons/arrow_down.svg" />
                  </div>
                </div>
              </div>
              <ProductionDetails :templateData="product" :parcel_surface="parcel_surface" v-show="product.expanded"></ProductionDetails>
            </div>
          </div>
        </div>
      </div>
    </DxScrollView>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { v4 } from "uuid";
import ProductionDetails from "./productionDetails.vue";

export default {
  name: "ConsolidateProduction",
  props: {
    parcel_uuid: {
      type: String,
      default: "",
    },
    parcel_name: String,
    parcel_group_parcel_uuids: {
      type: Array,
      default: () => [],
    },
    parcel_surface: String,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollListAttributes: {
        class: "con_consum_list_scroller",
      },
      pagination: {},
      scrollOffset_top: 0,
      production_list_data: {},
      noListData: false,
      totalValue: 0,
      totalValuePerHa: 0,
      totalWeightKg: 0,
      totalWeightKgPerHa: 0,
    };
  },
  components: {
    DxScrollView,
    ProductionDetails,
  },
  watch: {
    parcel_uuid(newVal, oldVal) {
      this.fillProduction(1, null, this.fillCallback);
    },
    parcel_group_parcel_uuids(newVal, oldVal) {
      this.fillProduction(1, null, this.fillCallback);
    },
  },
  methods: {
    ...mapActions({
      getParcelProduction: "smTransactions/getParcelProduction",
      getParcelProductionSummary: "smTransactions/getParcelProductionSummary",
    }),
    fillProduction(page_number, filter = null, callback = null) {
      if (this.visible == false) {
        return;
      }

      filter = filter ?? {};
      filter.page = page_number;
      if (page_number == 1) {
        this.$refs["scrollView"].instance.release(false);
      }
      /*this.getParcelProductionSummary({
        parcel_uuid:
          this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0
            ? this.parcel_group_parcel_uuids.join()
            : this.parcel_uuid,
      }).then((response) => {
        this.totalValue = response;
         if (parseFloat(this.parcel_surface) > 0) {
            this.totalValuePerHa = (parseFloat(this.totalValue.replace(",", "")) / parseFloat(this.parcel_surface)).toFixed(2);
        }
      });*/
      this.getParcelProduction({
        parcel_uuid:
          this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0 ? this.parcel_group_parcel_uuids : [this.parcel_uuid],
        page: page_number,
        limit: 10000,
      }).then((response) => {
        if (page_number == 1) {
          this.production_list_data = [];
          this.$set(this.production_list_data, []);
        }

        // Group the flat array by date
        const grouped = this.groupByDate(response);

        // Add UUIDs and expanded property
        let totalValue = 0;
        let totalWeightKg = 0;
        grouped.forEach((d) => {
          d.data_idx_uuid = v4();
          d.products.forEach((p) => {
            p.idx_uuid = v4();
            p.expanded = false;
            totalValue += parseFloat(p.price);
            totalWeightKg += parseFloat(p.quantity_kg);
          });

          this.production_list_data.push(d);
          this.$set(this.production_list_data, this.production_list_data.length - 1, d);
        });

        this.totalValue = parseFloat(totalValue).toFixed(2);
        if (parseFloat(this.parcel_surface) > 0) {
          this.totalValuePerHa = (parseFloat(this.totalValue) / parseFloat(this.parcel_surface)).toFixed(2);
        }

        this.totalWeightKg = parseFloat(totalWeightKg);
        if (parseFloat(this.parcel_surface) > 0) {
          this.totalWeightKgPerHa = parseFloat(this.totalWeightKg) / parseFloat(this.parcel_surface);
        }

        this.$emit("onProductionLoaded", {
          total_weight_kg: this.totalWeightKg,
        });

        this.pagination = response?.pagination ?? {};
        this.noListData = this.production_list_data.length == 0;
        if (callback != null) {
          callback();
        }
      });
    },
    groupByDate(array) {
      const groups = {};
      array.forEach((item) => {
        if (!groups[item.date]) {
          groups[item.date] = [];
        }
        groups[item.date].push(item);
      });
      // Convert to array of objects with date and products
      return Object.keys(groups).map((date) => ({
        date,
        products: groups[date],
      }));
    },
    fillCallback() {
      if (this.pagination.current_page == this.pagination.last_page || this.production_list_data.length == 0) {
        this.$refs["scrollView"].instance.release(true);
      } else {
        this.$refs["scrollView"].instance.release(false);
      }
      this.$refs["scrollView"].instance.update();
      if (this.pagination.current_page == 1) {
        this.$refs["scrollView"].instance.scrollTo(0);
      }
    },
    /*
    reachBottom() {
      if (this.pagination.current_page < this.pagination.last_page) {
        this.fillProduction(this.pagination.current_page + 1, null, this.fillCallback);
      }
    },
    */
    scroll(event) {
      this.scrollOffset_top = event.scrollOffset.top;
    },
    expandProduct(product, d_idx, p_idx) {
      product.expanded = !product.expanded;
    },
  },
  mounted() {
    this.fillProduction(1, null, this.fillCallback);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/components/consolidateConsum.scss";
</style>
